<template>
  <div class="container-fluid">
    <div class="row">
      <div class="col-12">
        <currentMeldungen />
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import AdminCurrentMeldungen from '@/widget/admin/AdminCurrentMeldungen.vue';

export default {
  name: "AdminMeldungen",
  data() {
    return {

    }
  },
  components: {
    currentMeldungen: AdminCurrentMeldungen
  },
  computed: {
    ...mapGetters({
      animations: "app/animations",
    })
  }
};
</script>

<style>

</style>
